import { logEvent, type Analytics } from 'firebase/analytics';
import { getFirebaseAnalytics } from './firebase';

const CONSENT_KEY = 'uga_cookie_consent';

export type AnalyticsConsent = 'accepted' | 'rejected' | null;

export function getAnalyticsConsent(): AnalyticsConsent {
  if (typeof window === 'undefined') return null;
  const value = localStorage.getItem(CONSENT_KEY);
  if (value === 'accepted' || value === 'rejected') return value;
  return null;
}

export function setAnalyticsConsent(consent: 'accepted' | 'rejected'): void {
  localStorage.setItem(CONSENT_KEY, consent);
}

export type AnalyticsEvent =
  | 'search_submitted'
  | 'filter_applied'
  | 'filter_cleared'
  | 'property_viewed'
  | 'property_shared'
  | 'whatsapp_clicked'
  | 'visit_requested'
  | 'property_inquiry_submitted'
  | 'owner_lead_started'
  | 'owner_lead_submitted'
  | 'valuation_requested'
  | 'legal_service_clicked'
  | 'contact_form_submitted'
  | 'guide_viewed';

let analyticsInstance: Analytics | null = null;

async function getAnalytics(): Promise<Analytics | null> {
  if (getAnalyticsConsent() !== 'accepted') return null;
  analyticsInstance ??= await getFirebaseAnalytics();
  return analyticsInstance;
}

export async function trackEvent(
  event: AnalyticsEvent,
  params?: Record<string, string | number | boolean>,
): Promise<void> {
  const analytics = await getAnalytics();
  if (!analytics) return;
  logEvent(analytics, event, params);
}
